module.exports = __webpack_public_path__ + "img/logoSintraadete.2f2d339a.png";